import Markdown from 'react-markdown';
import React from 'react';
import { graphql } from 'gatsby';
import Overlay from '../components/Overlay';
import SEO from '../components/seo';

function Vita (props) {
  const { data: { allMarkdownRemark: { edges: [data] } } } = props;
  const { node: { frontmatter: { vita } } } = data;

  return (
    <Overlay title="Vita">
      <SEO title="Vita"/>
      <Markdown source={vita} />
    </Overlay>
  );
}

export default Vita;

export const pageQuery = graphql`
    query Vita {
        allMarkdownRemark(
            sort: { order: DESC, fields: [frontmatter___date] }
            filter: { frontmatter: { templateKey: { eq: "vita" } } }
        ) {
            edges {
                node {
                    id
                    fields {
                        slug
                    }
                    frontmatter {
                        vita
                    }
                }
            }
        }
    }
`;
